import { render } from "./ViewSubmittedResponse.vue?vue&type=template&id=ab402388&scoped=true"
import script from "./ViewSubmittedResponse.vue?vue&type=script&lang=js"
export * from "./ViewSubmittedResponse.vue?vue&type=script&lang=js"

import "./ViewSubmittedResponse.vue?vue&type=style&index=0&id=ab402388&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ab402388"

export default script